import React from "react";
import LazyloadImage from "./LazyloadImage";
import { LeadImage } from "./leadImage";

export default class PhotoDetailImage extends React.Component {
  static defaultProps = {
    containerClassName: 'photo',
    desktopWidth: 729,
    mobileWidth: 353
  };

  render() {
    let { is_mobile, isLeadImage } = this.props;
    let lazy = !isLeadImage;
    let mediaEnv = process.env.RAILS_ENV == 'production' ? '' : 'qa-';

    return (isLeadImage && is_mobile) ?
            <LeadImage
              mediaEnv={mediaEnv}
              {...this.props}
            >
            </LeadImage>
            :
            <LazyloadImage lazy={lazy} {...this.props}></LazyloadImage>
  }
}